<template>
    <el-card shadow="never" class="l-main-card">
        <div class="l-container-sider">
            <l-applet-org-list @on-before-check="loading = true" @on-after-check="aftercheckOrg"></l-applet-org-list>
        </div>
    
        <div class="l-container-content" v-loading="loading">
            <!-- <div class="l-menu-box"> -->
<!--            <div class="l-container-title"><i class="el-icon-user-solid" /><b>负责人管理</b>
            </div> -->
            <!-- <div class="l-menu-list-main" style="bottom: 0; top: 30px"> -->
            <div class="l-table-toolbar" style="text-align: right">
                <l-auth-button class="ivu-mr" type="primary" auth="org_duty_create_btn" @click="onAddOrgDuty();"> 新增
                </l-auth-button>
                <div class="l-simple-search-container" style="float: right;">
                    <el-input placeholder="姓名/手机号" v-model="search_data.keywords" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
                    </el-input>
                </div>
            </div>
            <div>
                <l-table :data="data" v-loading="loading" row-key="id">
                    <el-table-column v-for="(item,index) in columns" :key="index" v-bind="{...item}" :label="item.label" show-overflow-tooltip>
                    <template v-slot="{row}">
                        <template v-if="item.prop=='org_id'">
                            <el-cascader v-model="row.org_id" :options="org_tree_node" :props="{ checkStrictly: true }" clearablev v-show="row.show"></el-cascader>
                            <span v-show="!row.show">{{row.org_path}}</span>
                        </template>
                        
                        <template v-else-if="item.prop=='is_active'">
                            <el-switch v-show="row.show" v-model="row.is_active" :active-value="1" :inactive-value="0" active-text="">
                            </el-switch>
                            <el-tag v-show="!row.show" :type="row.is_active == 1 ? 'success' : 'danger'" size="small" disable-transitions>{{ row.active_state }}</el-tag>
                        </template>
                        
                        <template v-else-if="item.prop=='moduler_ids'">
                            <el-select v-model="row.moduler_ids" multiple placeholder="请选择模块类型(可多选)" :disabled="moduler_list.length==0" v-show="row.show" >
                                <el-option v-for="item in moduler_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
                            </el-select>
                            <el-tag v-show="!row.show" size="small" type="success" disable-transitions v-for="(item,id) in row.moduler_list" :key="id">
                                {{item.name}}
                            </el-tag>
                            <!-- <el-tag size="small" type="success" disable-transitions v-for="(item,id) in row.moduler_list" :key="id">
                                {{item.name}}
                            </el-tag> -->
                        </template>
                        
                        <template v-else-if="item.prop=='org_charger'">
                         <el-input v-model="row.org_charger" autocomplete="off" placeholder="请输入负责人姓名" 
                             v-show="row.show" />
                         <span v-show="!row.show">{{row.org_charger}}</span>
                        </template>

                        <template v-else-if="item.prop=='org_charger_tel'">
                         <el-input v-model="row.org_charger_tel" autocomplete="off" placeholder="请输入负责人电话" 
                             v-show="row.show" />
                         <span v-show="!row.show">{{row.org_charger_tel}}</span>
                        </template>

                        <template v-else-if="item.prop=='org_contact'">
                         <el-input v-model="row.org_contact" autocomplete="off" placeholder="请输入联系人姓名" 
                             v-show="row.show" />
                         <span v-show="!row.show">{{row.org_contact}}</span>
                        </template>

                        <template v-else-if="item.prop=='org_contact_tel'">
                         <el-input v-model="row.org_contact_tel" autocomplete="off" placeholder="请输入联系人电话" 
                             v-show="row.show" />
                         <span v-show="!row.show">{{row.org_contact_tel}}</span>
                        </template>
            
                        <template v-else>{{row[item.prop]}}
                        </template>
                    </template>
                    </el-table-column>
        
                    <el-table-column fixed="right" label="操作" width="240" align="center">
                    <template slot-scope="{ row }">
                        <l-auth-text-button type="primary" auth="org_duty_edit_btn" @click="edit(row,'edit')" v-show="!row.show">
                            <i class="el-icon-edit"></i>编辑
                        </l-auth-text-button>
                        <l-auth-text-button type="primary" auth="org_duty_edit_btn" @click="edit(row,'save')" v-show="row.show">
                            <i class="el-icon-edit"></i>保存
                        </l-auth-text-button>
                        <l-auth-text-button type="primary" auth="org_duty_edit_btn" @click="edit(row,'cancel')" v-show="row.show">
                            <i class="el-icon-edit"></i>取消
                        </l-auth-text-button>
                        <span class="l-action-separator">|</span>
                        <l-auth-text-button type="danger" auth="org_duty_del_btn" @click="del(row.id)"><i class="el-icon-delete"></i> 删除
                        </l-auth-text-button>
                    </template>
                    </el-table-column>
                </l-table>
                <l-page :total="count" @current-change="getList" @size-change="getList" :page-size.sync="page_size" :current-page.sync="page"></l-page>
            </div>
            <!-- </div> -->
        </div>

        <l-dialog :visible.sync="addOrgDutyVisible" title="创建组织架构人员" width="1000px">
            <l-org-duty-edit @on-success="onAddOrgDutySucess" :visible.sync="addOrgDutyVisible" :org_id="org_id" />
        </l-dialog>
    </el-card>
</template>

<script>
import Vue from "vue";
import Edit from "./Edit";
import DutyEdit from "./DutyEdit";
import OrgList from "../../applet_org/List.vue";

let columns = [
  {
    prop: "index",
    label: "序号",
    fixed: true,
    width: "60",
  },
  {
    prop: "is_active",
    label: "启用标识",
    fixed: false,
    minWidth: "80",
    // render: (h, { row }) => {
    //     return (
    //       <Tag color={row.state == 1 ? 'success' : 'danger'}>{this.STATE_NAMES[row.state]}</Tag>
    //     );
    // }
    // render: (h, { row }) => {
    //   return (
    //       <el-tag type={row.state == 1 ? 'success' : 'danger'} size="small"
    //         onClick={() => this.changeState(row)}
    //         disable-transitions>{this.STATE_NAMES[row.state]}</el-tag>
    //   )
    // }
  },
  {
    prop: "org_id",
    label: "组织架构",
    fixed: true,
    width: "180",
  },
    // {
    //   prop: "org_path",
    //   label: "组织架构",
    //   fixed: true,
    //   width: "140",
    // },
  {
    prop: "org_charger",
    label: "负责人姓名",
    fixed: true,
    width: "140",
  },
  {
    prop: "org_charger_tel",
    label: "负责人电话号码",
    fixed: false,
    minWidth: "120",
  },
  {
    prop: "org_contact",
    label: "联系人姓名",
    fixed: false,
    minWidth: "120",
  },
  
  {
    prop: "org_contact_tel",
    label: "联系人电话号码",
    fixed: false,
    minWidth: "120",
  },
  {
    prop: "moduler_ids",
    label: "管理的模块类型",
    fixed: false,
    minWidth: "200",
  },

];

export default {
  name: "l-org-manage",
  components: {
    [Edit.name]: Edit,
    [DutyEdit.name]: DutyEdit,
    [OrgList.name]: OrgList
  },
  data() {
    return {
        data: [],
        count: 0,
        page: 1,
        page_size: Vue.$_config.page.page_size,
        loading: false,

        tree_data: [],
        org_tree_node: [],
        moduler_list: [],
        select_id: null,
        show_action_id: null,

        add_visible: false,
        addOrgDutyVisible: false,
        pid: "",
        org_id: 0,
        edit_visible: false,
        edit_id: "",
        search_data: {
            keywords: "",
        },
        re_fixed_list: ["index", "state"],
        fixed_list: ["index", "state"],
    };
  },
  computed: {
    columns() {
      let result = columns.map((item) => {
        const index = this.fixed_list.findIndex((itm) => {
          return itm == item.prop;
        });
        if (index != -1) {
          item.fixed = true;
          if (!item.width) {
            item.width = item.minWidth;
          }
        } else {
          if (item.minWidth && item.width) {
            delete item.width;
          }
          item.fixed = false;
        }
  
        return item;
      });
  
      return result;
    },
  },
  watch: {
    fixed_list(val) {
      if (val.length > 3) {
        this.fixed_list.shift();
      }
    },
  },
  mounted() {
      console.log('mounted:' + this.addOrgDutyVisible);
    this.getList();
  },
  methods: {
      //加载列表方法
      aftercheckOrg(org_id) {
       
        this.getList(org_id);
      },
      //点击搜索按钮
      onSearch() {
        this.page = 1;
        this.rel_search_data = this.search_data;
        this.getList();
      },
      onAddOrgDuty() {
        this.addOrgDutyVisible = true;
        // console.log('onAddOrgDuty:'+this.addOrgDutyVisible);
      },
      //添加成功回调
      onAddSucess() {
        this.add_visible = false;
        this.getList();
      },
    //获取组织架构数据
    getList(org_id) {
        this.org_id = org_id;
        this.loading = true;
        this.$_invoke("uniOrg_getDutyList", {
          page: this.page,
          page_size: this.page_size,
          org_id: org_id,
          ...this.rel_search_data,
        })
          .then((ret) => {
            this.data = ret.data;
            this.count = ret.count;
            this.org_tree_node = ret.org_tree_node;
            this.moduler_list = ret.moduler_list;
          })
          .finally(() => {
            this.loading = false;
          });
      // this.loading = true;
      // this.$_invoke("uniOrg_getTree")
      //   .then((ret) => {
      //     this.tree_data = ret.tree_data;
      //     if (!this.select_id) {
      //       if (this.tree_data.length > 0) {
      //         this.checkOrg(this.tree_data[0].id);
      //       }
      //     }
      //   })
      //   .finally(() => {
      //     this.loading = false;
      //   });
    },
    //显示添加组织架构弹窗
    showAdd(pid) {
      this.pid = pid;
      this.add_visible = true;
    },

    //选中某个组织
    checkOrg(id) {

      this.$emit("on-before-check");
      this.$nextTick(() => {
        this.select_id = id;
        this.$refs.tree.setCurrentKey(id);
        this.$emit("on-after-check", id);
      });
    },

    //添加成功回调
    onAddOrgDutySucess() {
      // this.pid = "";
      // console.log('call back:'+this.addOrgDutyVisible);
      this.addOrgDutyVisible = false;
      this.getList(this.org_id);
    },

    //显示编辑
    showEdit(id) {
      this.edit_id = id;
      this.edit_visible = true;
    },

    //编辑成功回调
    onEditSuccess() {
      this.edit_id = "";
      this.edit_visible = false;
      this.getList();
    },
    
    //编辑/保存，改变状态
    edit(row, mode) {
        // console.log(row.show);
        if (mode == "edit") {
            row.show = true;
        } else {
            row.show = false;
        }
    
        //save
        if (mode == "save") {
            let sel_org_id = row.org_id;
            if (typeof sel_org_id != "number") {
              const pid_len = sel_org_id.length;
              sel_org_id = sel_org_id[pid_len - 1];
            }
            
            
            this.submitting = true;
            // if (this.hasId) {
                this.$_invoke('uniOrg_updateOrgDuty', {id: row.id, 
                                                                org_charger: row.org_charger, 
                                                                org_charger_tel: row.org_charger_tel,
                                                                org_contact: row.org_contact,
                                                                org_contact_tel: row.org_contact_tel,
                                                                is_active: row.is_active,
                                                                org_id: sel_org_id,})
                    .then(() => {
                this.$_msg.success('修改成功');
                this.getList(this.org_id);
              }).finally(() => {
                this.submitting = false;
              })
            // }
        }
    },

    //删除
    del(id) {
      this.$confirm("确认删除该负责人吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`uniOrg_deleteOrgDuty`, { id }).then(() => {
            this.$_msg.success("删除成功");
            this.getList(this.org_id);
          });
        })
        .catch(() => {});
    },

    //点击节点
    handleNodeClick(data) {
      this.checkOrg(data.id);
    },
  },
};
</script>

<style lang="scss" scoped>
// .l-elipsis {
//   max-width: 60%;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: inline-block;
//   vertical-align: middle;
// }
</style>
